var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"water_box"},[_c('div',{staticClass:"pos_pointer",style:(`bottom:${
      ((_vm.waterPosition - 500) / 30) * 100 - 20 > 0 ? ((_vm.waterPosition - 500) / 30) * 100 - 20 : 0
    }%`)},[_vm._v(" "+_vm._s(_vm.waterPosition)+"m ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }